/**
 * File: useSalesHomeController.ts
 * Path: apps/admin/src/features/dashboard/hooks/useSalesHomeController.ts
 * Description: Sales staff land on Today. Anyone who also has analytics gets a Website tab (?tab=website).
 */

import { useSearchParams } from "react-router-dom";
import { useRole } from "@/modules/auth/hooks/useRoleQueries";

export const useSalesHomeController = () => {
  const { can } = useRole();
  const [params, setParams] = useSearchParams();
  const showWebsite = can("analytics");
  const tab = showWebsite && params.get("tab") === "website" ? "website" : "today";
  const changeTab = (value: string) => setParams(value === "today" ? {} : { tab: value }, { replace: true });
  return { showWebsite, tab, changeTab };
};
